/**
 * Created by yibrahim on 13/07/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent }   from './page-not-found.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { ForbiddenPageComponent } from './forbidden-page/forbidden-page.component';

const appRoutes: Routes = [
  { path: '',   redirectTo: '/search', pathMatch: 'full' },
  { path: 'welcome', component: WelcomePageComponent },
  { path: 'forbidden', component: ForbiddenPageComponent },
  { path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts